<template>
    <div style="width: 100%;cursor: pointer;" @click.stop="addCart">
        加入购物车
    </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { useStore } from 'vuex'

import { useRouter } from "vue-router";
const router = useRouter();
const store = useStore()
const userInfo = computed(() => store.state.user.userInfo) //ref(true)//;

const cartPosition = computed(() => store.state.cartPosition.cartPosition)
const props = defineProps(['product'])
const emits = defineEmits(['addParentCart'])
function addCart(event){
  // console.log(userInfo.value)
  if(!userInfo.value){
    store.commit('CLEAR_token')
    store.dispatch('clear_productsCart')
    store.dispatch('clear_userInfo')
    store.dispatch('clear_navsList')
    router.replace('/login')
    emits("addParentCart",props.product)
  }else{
    // if(userInfo.value.isCollege){
    //   return
    // }
    const x = event.clientX -20;
    const y = event.clientY - 20;
    createBall(x, y, props.product.src);//document.body.clientWidth-x
    emits("addParentCart",props.product)
  }
}
function createBall(left, top, src) {
    const bar = document.createElement("img");
    bar.style.position = "fixed";
    bar.style.left = left + "px";
    bar.style.top = top + "px";
    bar.style.zIndex = "1000";
    bar.style.width = "40px";
    bar.style.height = "40px";
    bar.style.borderRadius = "50%";
    bar.src = src
    bar.style.transition =
      "left .6s linear, top .6s cubic-bezier(0.5, 1.5, 1, 1)";
    document.body.appendChild(bar);
    let timer = setTimeout(() => {
      const x = cartPosition.value//document.body.clientWidth * 0.5;
      const y = document.body.clientHeight * 0.5 + 86;
      bar.style.top = y + "px";
      bar.style.left = x + "px";
      clearTimeout(timer)
    }, 0);
    bar.ontransitionend = function () {
      this.remove();
    };
  }
</script>